import {
    CURRICULO_GET_DADOS,
    CURRICULO_GET_AGENDA_VENCIDA,
    CURRICULO_FECHAR_AGENDA_VENCIDA,
    CURRICULO_APROVADO_REPROVADO_RESERVAR_CANDIDATO,
    CURRICULO_REMOVER_CANDIDATO_AGENDA_VENCIDA,
    CURRICULO_GET_AGENDA_OUTROS,
    CURRICULO_GET_MINHA_AGENDA,
    CURRICULO_REMOVER_MINHA_AGENDA,
    CURRICULO_UPD_AGENDA,
    CURRICULO_ADD_AGENDA,
    CURRICULO_GET_DETALHES_CURRICULO_LIMPAR,
    CURRICULO_GET_DETALHES_CURRICULO,
    CURRICULO_ADD_FAVORITO,
    CURRICULO_DEL_FAVORITO,
    CURRICULO_GET_LISTA_MINHA,
    CURRICULO_GET_LISTA_OUTROS,
    CURRICULO_LISTA_DE_ESPERA_LIMPAR,
    CURRICULO_GET_HISTORICO_CURRICULO,
    CURRICULO_FECHAR_HISTORICO_CURRICULO,
    CURRICULO_REMOVER_CANDIDATO_LISTA_ESPERA,
    CURRICULO_LIMPAR_MINHA_AGENDA,
    CURRICULO_GET_CURRICULO_POR_PAGINA,
    CURRICULO_FILTRO_AVANCADO_APLICAR,
    CURRICULO_FILTRO_AVANCADO_LIMPAR,
    CURRICULO_SET_DRAWER,
    CURRICULO_FECHAR_DRAWER
    
} from '../actions/curriculo-actions';


export default function curriculoReducer(state = {}, action){
    switch(action.type){
        case CURRICULO_GET_DADOS: // Para os dados iniciais
            return {
                ...state,
                ...action.data
            }
        case CURRICULO_GET_AGENDA_VENCIDA: // Para a agenda vencida do usuario
            return {
                ...state,
                agendaVencida: action.data
            };
        case CURRICULO_FECHAR_AGENDA_VENCIDA: // Para limpar localmente a agenda vencida (se nada for feito irá aparecer sempre)
            return {
                ...state,
                agendaVencida: []
            }
        case CURRICULO_APROVADO_REPROVADO_RESERVAR_CANDIDATO: // Para remover (se encontrar) o curriculo da listagem do corpo
            return (()=>{
                const { corpo, agenda, agendaVencida, listaDeEspera, tipoLista } = state;
                // Se este candidato esta no corpo, precisa ser removido
                const copiaCorpo = corpo.filter(ele=> String(ele.id) !== String(action.data.id_curriculo) );
                // Se ele esta na agenda vencida precisa ser removido
                const copiaAgendaVencida = agendaVencida.filter(ele=> String(ele.id_curriculo) !== String(action.data.id_curriculo) );
                // Se ele se encontar na lista de espera (caso ela esteja aberta) precisa ser removido
                let copiaListaDeEspera = listaDeEspera;
                let tipoListaCopia = tipoLista;
                if(copiaListaDeEspera){
                    copiaListaDeEspera = copiaListaDeEspera.filter(ele=> String(ele.id_curriculo) !== String(action.data.id_curriculo) );
                    // Se não tiver mais candidatos na lista de espera limpe o dados
                    if(copiaListaDeEspera.length < 1){
                        copiaListaDeEspera = null;
                        tipoListaCopia = null;
                    }
                }
                // Se ele estiver na agenda (caso ela exista) precisa ser removido 
                let copiaAgenda = agenda?.minhaAgenda;
                if(copiaAgenda){
                    // {AAAA-MM-DD: [{id_agenda, ..., id_curriculo }]}
                    // Faz um loop sobre o objeto da agenda, atualiza cada array dentro procurando o curriculo e removendo da agenda
                    copiaAgenda = {};
                    
                    Object.keys(agenda?.minhaAgenda).forEach(key=>{
                        
                        copiaAgenda[key] = agenda?.minhaAgenda[key].filter(ele=> String(ele.id_curriculo) !== String(action.data.id_curriculo) );
                    });
                } else {
                    copiaAgenda = {};
                }
                
                return {
                    ...state,
                    'corpo': copiaCorpo,
                    'agendaVencida': copiaAgendaVencida,
                    tipoLista: tipoListaCopia,
                    listaDeEspera: copiaListaDeEspera,
                    agenda: copiaAgenda,
                    tipoAgenda: Object.keys(copiaAgenda)?.length < 1 ? null : state.tipoAgenda
                }
            })();
        case CURRICULO_REMOVER_CANDIDATO_AGENDA_VENCIDA: // Filtar e remove a agenda indicada id_agenda
            return {
                ...state,
                agendaVencida: state.agendaVencida.filter(ele=> String(ele.id_agenda) !== String(action.data) )
            }
        case CURRICULO_GET_AGENDA_OUTROS: // Para criar o objeto da agenda dos outros
            return {
                ...state,
                agenda: action.data.dados,
                tipoAgenda: action.data.tipoAgenda
            }
        case CURRICULO_GET_MINHA_AGENDA: // Para criar objeto com a minha agenda
            return {
                ...state,
                agenda: action.data.dados,
                tipoAgenda: action.data.tipoAgenda
            }
        case CURRICULO_REMOVER_MINHA_AGENDA: // Para remover o candidato da agenda
            return (()=>{
                const { agenda } = state; // Pega a agenda
                const { id_agenda, data } = action.data; // Pega o id_agenda e a data
                // Filtra pela data em agenda e exclui a agenda encontrada
                const diaAgenda = agenda[data].filter(ele=> String(ele.id_agenda) !== String(id_agenda) );
                if(diaAgenda.length < 1){
                    delete agenda[data];
                } else {
                    agenda[data] = diaAgenda;
                }
                
                return {
                    ...state,
                    agenda: agenda,
                }
            })();
        case CURRICULO_ADD_AGENDA: // Para adicionar o curriculo a agenda ( necessariamente e remove-lo da pilha )
            return {
                ...state,
                corpo: state.corpo.filter(ele=> String(ele.id) !== String(action.data)),
            }
        case CURRICULO_UPD_AGENDA: // Action para atualizar agenda
            return (()=>{
                const { agenda } = state;
                const { dados, data, id_agenda } = action.data; // {AAAA-MM-DD: {}}, data_antiga, id_agenda
                // Veja se o dia existe na agenda
                if(agenda[data]){
                    // Filtra pela data antiga em que agenda existia e exclui a agenda encontrada
                    const diaAgenda = agenda[data]?.filter(ele=> String(ele.id_agenda) !== String(id_agenda) );
                    agenda[data] = diaAgenda;
                }
                // Se a data_antiga for um array vazio pode elimina-la
                if(agenda[data].length < 1){
                    delete agenda[data];
                }
                // O objeto dados vem com a data sendo a chave para insercao
                const novaData = Object.keys(dados)[0]; // Extrai a data retornada para usa-la na insercao dos dados
                // Se a novaData nao existir no objeto crie-a
                if(!agenda[novaData]){
                    agenda[novaData] = [];
                }
                // Adiciona os novos dados no dia correto da agenda
                agenda[novaData].push(dados[novaData]);
                                
                return {
                    ...state,
                    agenda: agenda,
                }

            })();
        case CURRICULO_LIMPAR_MINHA_AGENDA: // Para limpar variaveis da agenda
            return {
                ...state,
                agenda: null,
                tipoAgenda: null,
            }
        case CURRICULO_GET_DETALHES_CURRICULO: // Para registrar o campo detalhesCurriculo onde exibiremos os detalhes deste curriculo
            return {
                ...state,
                detalhesCurriculo: action.data
            }
        case CURRICULO_GET_DETALHES_CURRICULO_LIMPAR: // Para limpar o campo detalhesCurriculo (isto indica a limpeza deste campo)
            return {
                ...state,
                detalhesCurriculo: null,
            }
        case CURRICULO_ADD_FAVORITO: // Adicionando ao sisteam dos favoritos
            return (()=>{
                const { data } = action.data;
                const { favoritos } = state;
                // Adiciona o favorito 
                favoritos.push(data);

                return {
                    ...state,
                    favoritos,
                }
            })();
        case CURRICULO_DEL_FAVORITO: // Para excluir os favoritos
            return (()=>{
                const { id_curriculo } = action.data;
                const { favoritos } = state;
                ///
                return {
                    ...state,
                    favoritos: favoritos.filter(ele=> String(ele.id) !== String(id_curriculo) ),
                }
            })();
        case CURRICULO_GET_LISTA_MINHA: // Para quando a minha lista de espera é recuperada
            return {
                ...state,
                listaDeEspera: action.data.dados,
                tipoLista: action.data.tipoLista,
            }
        case CURRICULO_GET_LISTA_OUTROS: // Para quando a lista de espera é dos outros
            return {
                ...state,
                listaDeEspera: action.data.dados,
                tipoLista: action.data.tipoLista
            }
        case CURRICULO_LISTA_DE_ESPERA_LIMPAR: // Para limpar localmente todas as variaveis que fazem referencia a lista de espera
            return {
                ...state,
                listaDeEspera: null,
                tipoLista: null,
                tipoAgenda: null,
            }
        case CURRICULO_GET_HISTORICO_CURRICULO: // Para ver o historico do curriculo
            return {
                ...state,
                historicoCurriculo: action.data
            }
        case CURRICULO_FECHAR_HISTORICO_CURRICULO: // Para limpar o historico do curriculo
            return {
                ...state,
                historicoCurriculo: null,

            }
        case CURRICULO_REMOVER_CANDIDATO_LISTA_ESPERA: // Para remover o candidato da lista de espera
            return (()=>{
                const { listaDeEspera } = state;
                let copiaListaDeEspera = listaDeEspera;
                // Se tiver lista de espera, remova os curriculos de la
                if(listaDeEspera){
                    copiaListaDeEspera = listaDeEspera.filter(ele=> String(ele.id_curriculo) !== String(action.data));
                }
                //
                return {
                    ...state,
                    listaDeEspera: copiaListaDeEspera,
                    historicoCurriculo: null
                }
            })();
        case CURRICULO_GET_CURRICULO_POR_PAGINA: // Para gerar paginacao no sistema
            return {
                ...state,
                corpo: action.data
            }
        case CURRICULO_FILTRO_AVANCADO_APLICAR: // Para definir e preencher o filtro avancado
            return {
                ...state,
                filtro: action.data
            }
        case CURRICULO_FILTRO_AVANCADO_LIMPAR: // Para limpar o filtro avancado
            return {
                ...state,
                filtro: null
            }
        case CURRICULO_SET_DRAWER: // Para exibir um drawer
            return {
                ...state,
                oldDrawer: action.keepOld ? state.drawer : null,
                drawer: action.data,
            }
        case CURRICULO_FECHAR_DRAWER: // Para fechar o drawer (Se tiver o oldDrawer ele deve passar a ser o drawer a ser aberto.)
            return {
                ...state,
                drawer: state?.oldDrawer ? state.oldDrawer : null,
                oldDrawer: null,
            }
        default:
            return state;
    }
}